module.exports = __webpack_public_path__ + "static/media/ico-arrow-down.78ebc6b1.svg";